import { create } from 'zustand'
import ApiClient from '../views/api/client'

const apiClient = new ApiClient()

export const useSearchStore = create((set, get) => ({
  programs: [],
  clients: [],
  familyFiles: {},
  filteredFiles: [],
  filteredClients: [],
  filteredPrograms: [],
  searchQuery: '',
  loading: false,
  error: '',

  //client search state
  setClients: (clients) => {
    set({ clients, filteredClients: clients })
  },

  setPrograms: (programs) => {
    set({ programs, filteredPrograms: programs })
  },

  setSearchQuery: (query) => {
    set({ searchQuery: query })
    get().filterClients(query)
    get().filterPrograms(query)
  },

  filterClients: (query) => {
    const lowerQuery = query.toLowerCase()
    const { clients } = get()

    const filtered = clients.filter(
      (client) =>
        client?.client_name?.toLowerCase().includes(lowerQuery) ||
        client?.id?.toString().includes(lowerQuery) ||
        client?.program?.name?.toLowerCase().includes(lowerQuery)
    )

    set({ filteredClients: filtered })
  },

  filterPrograms: (query) => {
    const lowerQuery = query.toLowerCase()
    const { programs } = get()

    const filtered = programs.filter(
      (program) =>
        program?.name?.toLowerCase().includes(lowerQuery) ||
        program?.id?.toString().includes(lowerQuery) ||
        program?.program_code?.toLowerCase().includes(lowerQuery)
    )

    set({ filteredPrograms: filtered })
  },

  filterFiles: (query) => {
    const lowerQuery = query.toLowerCase()
    const { famFiles } = get()

    const filtered = famFiles.filter(
      (files) =>
        files?.name?.toLowerCase().includes(lowerQuery) ||
        files?.file_type?.toLowerCase().includes(lowerQuery) ||
        files?.created_at?.toLowerCase().includes(lowerQuery)
    )
    set({ filteredFiles: filtered })
  },

  // Get All Client
  getClientDetail: async (clientId) => {
    try {
      set({ loading: true })
      const response = await apiClient.getClientDetails(clientId)
      set((state) => ({
        clients: { ...state.clients, [clientId]: response.data },
        loading: false,
        error: null,
      }))
      return {
        success: true,
        message: `${response.data} fetched successfully!`,
      }
    } catch (err) {
      console.log('Error fetching client', err)
      set({ loading: true, error: err.response?.data?.detail || err.message })

      return { success: false, message: 'Failed to fetch client' }
    }
  },

  fetchPrograms: async () => {
    set({ loading: true })
    try {
      const response = await apiClient.fetchAllPrograms()
      set((state) => ({
        programs: [...state.programs, response.data],
        loading: false,
        error: null,
      }))
      return {
        success: true,
        message: `${response.data} created successfuly!`,
      }
    } catch (error) {
      set({
        error: error.response?.data?.detail || 'Error fetching programs',
        loading: false,
      })
      return { success: false, message: 'Failed to fetch client' }
    }
  },

  // fetch family member files
  fetchFamilyFiles: async (memberId) => {
    if (!memberId) {
      console.warn('❌ Skipping fetchFamilyFiles: memberId is missing')
      return
    }
    set({ loading: true, error: '' })
    try {
      const response = await apiClient.fetchFamilyMemberFiles(memberId)
      set((state) => ({
        familyFiles: { ...state.familyFiles, [memberId]: response.data },
        loading: false,
      }))
    } catch (err) {
      console.error('Error fetching client files', err)
      set({ error: err.response?.data?.detail || 'Error', loading: false })
    }
  },

  setError: (err) => set({ error: err }),
}))
